import { Link, useLocation } from 'react-router-dom'
import {
  LayoutGrid, Wallet, ArrowUpDown, Landmark, TrendingUp, Users,
  Briefcase, Building2, Settings2, Table2,
} from 'lucide-react'
import { ScrollArea } from '@/components/ui/scroll-area'
import { Separator } from '@/components/ui/separator'

// Route-based nav items — path matches the URL
export const FIN_NAV_ITEMS: { path: string; label: string; icon: typeof LayoutGrid }[] = [
  // Landing
  { path: '/',             label: 'Dashboard',    icon: LayoutGrid },
  // Daily / weekly operational loop
  { path: '/cash-flow',   label: 'Cash Flow',    icon: Wallet },
  { path: '/transactions',label: 'Transactions', icon: ArrowUpDown },
  { path: '/accounts',    label: 'Accounts',     icon: Landmark },
  { path: '/records',     label: 'Records',      icon: Table2 },
  // Periodic reporting
  { path: '/pl',          label: 'P&L',          icon: TrendingUp },
  { path: '/payroll',     label: 'Payroll',      icon: Users },
  { path: '/projects',    label: 'Projects',     icon: Briefcase },
  { path: '/capital',     label: 'Capital',      icon: Landmark },
  // Master data / admin
  { path: '/entities',    label: 'Entities',     icon: Building2 },
  { path: '/settings',    label: 'Settings',     icon: Settings2 },
]

interface FinSidebarProps {
  onMobileClose?: () => void
}

export function FinSidebar({ onMobileClose }: FinSidebarProps) {
  const location = useLocation()
  const isAnalytics = location.pathname === '/analytics'

  return (
    <>
      <ScrollArea className="flex-1">
        <div className="p-3">
          {/* ANALYTICS section — single item */}
          <div className="text-[10px] font-semibold text-muted-foreground uppercase tracking-widest px-2 mb-2">Analytics</div>
          <nav className="space-y-0.5 mb-1">
            <Link
              to="/analytics"
              onClick={onMobileClose}
              className={`w-full flex items-center gap-2 px-2 py-1.5 rounded-md text-xs font-medium transition-colors ${
                isAnalytics ? 'bg-primary/10 text-primary' : 'text-muted-foreground hover:text-foreground hover:bg-muted/50'
              }`}
            >
              <LayoutGrid className="h-3.5 w-3.5 shrink-0" />
              Analytics Dashboard
            </Link>
          </nav>

          <Separator className="my-3" />

          {/* FINANCIAL section */}
          <div className="text-[10px] font-semibold text-muted-foreground uppercase tracking-widest px-2 mb-2">Financial</div>
          <nav className="space-y-0.5">
            {FIN_NAV_ITEMS.map(item => {
              const Icon = item.icon
              const isActive = !isAnalytics && (
                item.path === '/'
                  ? location.pathname === '/'
                  : location.pathname.startsWith(item.path)
              )
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={onMobileClose}
                  className={`w-full flex items-center gap-2 px-2 py-1.5 rounded-md text-xs font-medium transition-colors ${
                    isActive ? 'bg-primary/10 text-primary' : 'text-muted-foreground hover:text-foreground hover:bg-muted/50'
                  }`}
                >
                  <Icon className="h-3.5 w-3.5 shrink-0" />
                  {item.label}
                </Link>
              )
            })}
          </nav>
        </div>
      </ScrollArea>

    </>
  )
}
